import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=39e73d8f&scoped=true&"
import script from "./TextList.vue?vue&type=script&lang=js&"
export * from "./TextList.vue?vue&type=script&lang=js&"
import style0 from "./TextList.vue?vue&type=style&index=0&id=39e73d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e73d8f",
  null
  
)

export default component.exports